export class Constants {
    //time in ms
    public static DEBOUNCE_TIME = 500;

}